// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PricedProductType } from './priced-product-type';
import { ProgramProductTypeTag } from './program-product-type-tag';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramProductTypeTagMap extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key FK pricedProductType */
  pricedProductTypeId!: string;
  /** Guid key FK programProductTypeTag */
  programProductTypeTagId!: string;
  /** FK pricedProductTypeId */
  pricedProductType!: PricedProductType;
  /** FK programProductTypeTagId */
  programProductTypeTag!: ProgramProductTypeTag;
}

